import React from 'react'
import Immutable from 'immutable';
import styled from 'styled-components';

import ParentBoundComponent from '../../components/parentboundcomponent';
import AdvancedSearchFormModel from './advancedsearchformmodel';
import Tree from '../../components/trees/tree';
import TabPane from '../../components/containers/tabpane';
import FlexBox from '../../components/containers/flexbox';
import FlexBoxBlock from '../../components/containers/flexboxblock';
import Button from '../../components/forms/button';
import Binder from '../../components/definitions/binder';
import RenderContext from '../../components/definitions/rendercontext';
import { getPhrase } from '../../data/phrases';
import { getLookup } from '../../data/lookupstore';
import { defaultTheme } from '../../data/themes';
import Icon from '../../components/icon';
import {showMessageBox} from '../../actions/modal';


const EMPTY_LIST = Immutable.List([]);






export default class AdvancedSearchFormModule extends ParentBoundComponent {
	constructor() {
		super();

		this.tabs = Immutable.fromJS([
			{
				id: 'queries',
				text: getPhrase('advancedSearchForm.queries')
			},
			{
				id: 'fieldTree',
				text: getPhrase('advancedSearchForm.fieldTree')
			}
		]);

		this.binder = new Binder({
			getData: this.getData,
			setData: this.setData,
			handleEvent: this.handleEvent,
			getLookup,
			getModel: this.getModel,
			setModel: this.setModel
		}, this);

		this.onSearchRequested = this.onSearchRequested.bind(this);
		this.clearFilter = this.clearFilter.bind(this);

		this.removeSelectedQuery = this.removeSelectedQuery.bind(this);
		this.saveQuery = this.saveQuery.bind(this);
		this.saveQueryAsNew = this.saveQueryAsNew.bind(this);
	}

	async removeSelectedQuery() {
		const dlgRes = await showMessageBox(getPhrase('confirm.removeQuery'), {type: 'confirm'});
		if (dlgRes === 'yes') {
			let model = this.getModel().removeSelectedQuery();
			this.setModel(model);
			model.saveQueries();
		}
	}

	async saveQuery(asNew) {
		let model = this.getModel();
		const selQuery = asNew ? null : model.getSelectedQuery();
		const name = await showMessageBox(getPhrase('queryName'), {
			type: 'input',
			input: selQuery ? selQuery.get('name') : ''
		});
		if (!name) {
			return;
		}
		model = model.createQuery(selQuery ? selQuery.get('id') : null, name);
		this.setModel(model);
		model.saveQueries();
	}

	async saveQueryAsNew() {
		return this.saveQuery(true);
	}

	clearFilter() {
		this.setData(this.getModel().clearFilter().getData());
	}

	onSearchRequested() {
		if (this.props.onSearchRequested) {
			this.props.onSearchRequested();
		}
	}

	handleEvent(eventType, params) {
		if (eventType === 'action') {
			this.onSearchRequested();
		}
	}

	getModel() {
		return new AdvancedSearchFormModel(this.getData());
	}

	setModel(model) {
		this.setData(model.getData());
	}

	renderForm(model) {
		const definition = model.getFormDefinition();
		if (!definition) {
			return null;
		}
		const ctx = new RenderContext(this.binder, ['filter']);
		return (
			<FormWrapper>
				<FlexBox vertical>
					<FlexBoxBlock flexShrink="1" overflow="auto" padding="4px">
						{definition.render(ctx)}
					</FlexBoxBlock>
					<FlexBoxBlock>
						<Button
							name="search"
							text={getPhrase('search')}
							onAction={this.onSearchRequested}
						/>
						<Button
							name="clearForm"
							text={getPhrase('clearForm')}
							type="light"
							onAction={this.clearFilter}
							padding="0px"
						/>
					</FlexBoxBlock>
				</FlexBox>
			</FormWrapper>
		)
	}

	renderTree(model) {
		return (
			<Tree
				selected={model.getSelectedNodes()}
				expanded={model.getExpandedNodes()}
				onExpandedChanged={expandedNodes => {
					this.setModel(model.setExpandedNodes(expandedNodes));
				}}
				onSelectedChanged={selectedNodes => {
					this.setModel(model.setSelectedNodes(selectedNodes));
				}}
				nodes={model.getNodes()}
			/>
		);
	}

	renderQueries(model) {
		return (
			<Queries
				queries={model.getQueries()}
				selectedQueryId={model.getSelectedQueryId()}
				onSelectedQueryChanged={id => {
					this.setModel(model.setSelectedQueryId(id));
				}}
			/>
		);
	}

	renderQueriesOrTree(model, showQueries) {
		const selectedQueryId = model.getSelectedQueryId();
		return (
			<QueryOrTreeWrapper>
				<FlexBox vertical={true} padding="4px">
					<FlexBoxBlock flexGrow="1">
						{
							showQueries ? this.renderQueries(model) : this.renderTree(model)
						}
					</FlexBoxBlock>
					<FlexBoxBlock>
						<QueryButtons>
							<Icon
								name="trash"
								hint={getPhrase('removeSelectedQuery')}
								active
								onMouseDown={e => this.removeSelectedQuery()}
								disabled={!selectedQueryId}
							/>
							<Icon
								name="save"
								className="right"
								hint={getPhrase('saveQuery')}
								active
								onMouseDown={e => this.saveQuery()}
								disabled={!selectedQueryId}
							/>
							<Icon
								name="add"
								className="right"
								hint={getPhrase('saveAsNewQuery')}
								active
								onMouseDown={e => this.saveQueryAsNew()}
							/>
						</QueryButtons>
					</FlexBoxBlock>
				</FlexBox>
			</QueryOrTreeWrapper>
		);
	}

	render() {
		const model = this.getModel();
		const selectedTabId = model.getSelectedTabId();

		const showQueries = selectedTabId === 'queries';
		return (
			<AdvancedSearchFormModuleWrapper>
				<TabPane
					tabs={this.tabs}
					selectedTabId={selectedTabId}
					onTabSelected={tabId => {
						this.setModel(model.setSelectedTabId(tabId));
					}}
				>
					<FlexBox vertical={showQueries}>
						<FlexBoxBlock width="280px" marginBottom={showQueries ? '4px' : null}>
							{this.renderQueriesOrTree(model, showQueries)}
						</FlexBoxBlock>
						<FlexBoxBlock flexGrow="1" width="280px">
							{this.renderForm(model)}
						</FlexBoxBlock>
					</FlexBox>
				</TabPane>
			</AdvancedSearchFormModuleWrapper>
		);

	}
}

const AdvancedSearchFormModuleWrapper = styled.div`
	position: relative;
	background: ${props => props.theme.advancedSearchFormBackground};
	max-width: 560px;
	margin-right: 16px;
	height: 100%;
`;

const QueryButtons = styled.div`
	position: relative;
	width: 100%;
	height: 100%;

	padding: ${props => props.theme.treePadding || defaultTheme.treePadding};
	background: ${props => props.theme.advancedSearchFormQueryListBackground || defaultTheme.advancedSearchFormQueryListBackground || props.theme.treeBackground};

	padding: 2px 16px 4px 16px;

	.icon {
		font-size: 17px;
		color: ${props => props.theme.advancedSearchFormQueryListIconColor || defaultTheme.advancedSearchFormQueryListIconColor};
		&:not(.right) {
			margin-right: 8px;
		}

		&.right {
			float: right;
			margin-left: 8px;
		}
	}
`;



const FormWrapper = styled.div`
	width: 100%;
	height: 100%;
	position: relative;

	.ps-formItem {
		margin-bottom: 10px;

		.rightIcons {
			[data-name=pencil] {
				font-size: 12px;
				position: relative;
				top: -1px;
			}
		}

		.leftIcons {
			.icon {
				font-size: 12px;
				position: relative;
				margin-right: 4px;
				top: -1px;

				&[data-name=emptyOn], &[data-name=notEqual] {
					color: ${props => props.theme.errorColor};
				}
			}
		}
	}

	.ps-button {
		width: 180px;
		margin: 8px auto;
		display: table;
	}
`;

const QueryOrTreeWrapper = styled.div`
	position: relative;
	width: 100%;
	height: 100%;
	overflow: hidden;
	border: ${props => props.theme.advancedSearchFormQueryOrTreeBorder};
	border-bottom: ${props => props.theme.advancedSearchFormQueryOrTreeBorderBottom};
	border-radius: ${props => props.theme.advancedSearchFormQueryOrTreeBorderRadius};
	background: ${props => props.theme.advancedSearchFormQueryOrTreeBackground};

`;


const QueryWrapper = styled.div`
	position: relative;
	width: 100%;
	height: 100%;
	overflow: auto;
	max-height: 100px;

	padding: ${props => props.theme.treePadding || defaultTheme.treePadding};
	background: ${props => props.theme.advancedSearchFormQueryListBackground || defaultTheme.advancedSearchFormQueryListBackground || props.theme.treeBackground};
`;

const Query = styled.div`
	padding: ${props => props.theme.listItemPadding || defaultTheme.listItemPadding};
	cursor: pointer;
	&:hover {
		text-decoration: underline;
	}
	&.selected {
		background: ${props => props.theme.listSelectedItemBackground || defaultTheme.listSelectedItemBackground};
		font-weight: ${props => props.theme.listSelectedItemFontWeight || defaultTheme.listSelectedItemFontWeight};
		color: ${props => props.theme.listSelectedItemColor || defaultTheme.listSelectedItemColor};
	}
`;

class Queries extends React.PureComponent {
	render() {
		return (
			<QueryWrapper>
				{
					this.props.queries.map((query, index) => {
						return (
							<Query
								key={index}
								className={query.get('id') === this.props.selectedQueryId ? 'selected' : ''}
								onMouseDown={e => {
									e.preventDefault();
									e.target.focus();
									this.props.onSelectedQueryChanged(query.get('id'))
								}}
							>
								{query.get('name')}
							</Query>
						);
					})
				}
			</QueryWrapper>
		)
	}
}

